module.exports = __webpack_public_path__ + "static/media/Madfit-16.c1c7e8f0.jpg";